import React from 'react'

export default function CountdownCard(props) {
  const {placeholder, number} = props;
  
  return (
    <div className="flex flex-col gap-2 items-center">
      <div className="rounded-md bg-primary text-white text-center md:text-[72px] text-[48px] font-bold md:w-[100px] w-[70px] md:h-[105px] h-[72px]">{number}</div>
      <div className="text-white font-bold">{placeholder}</div>
    </div>
  )
}
